import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut } from "../../api/index";
import {
  urlWorkingPartsProtected,
  urlA3Protected,
  urlA3multipleSecured,
  urlWorkingPartsAllProtected,
  urlJourneyA3Protected,
  urlA3multipleJourneysSecured,
  urlWorkingPartExportProtected,
} from "../../api/urls";
import { PAGE_SIZE_10 } from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.month !== undefined) filter += "&month=" + filters.month;
    if (filters.year !== undefined) filter += "&year=" + filters.year;
    if (filters.employeeID !== undefined)
      filter += "&employeeID=" + filters.employeeID;
    if (filters.employeeName !== undefined)
      filter += "&employeeName=" + filters.employeeName;
    if (filters.employeeCode !== undefined)
      filter += "&employeeCode=" + filters.employeeCode;
    // if (filters.showError !== undefined && filters.status === undefined)
    //   filter += "&showError=" + filters.showError;
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

const generateFilterQueryAll = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  if (filters) {
    if (filters.month !== undefined) filter += "&month=" + filters.month;
    if (filters.year !== undefined) filter += "&year=" + filters.year;
    if (filters.employeeID !== undefined)
      filter += "&employeeID=" + filters.employeeID;
    // if (filters.showError !== undefined && filters.status === undefined)
    //   filter += "&showError=" + filters.showError;
  }
  if (sort) filter += "&sort=" + sort;
  return filter;
};

/**
 * Filter list working parts.
 */
export const filterWorkingPart = createAction(
  "FILTER_WORKING_PART",
  (filter, param) =>
    apiGet(
      urlWorkingPartsProtected + generateFilterQuery(filter),
      param,
      true,
    )(),
);

export const getWorkingPart = createAction(
  "GET_WORKING_PART_BY_UUID",
  (param) => apiGet(urlWorkingPartsProtected, param, true)(),
);

export const updateRestHours = createAction("UPDATE_REST_HOURS", (uuid, data) =>
  apiPut(urlWorkingPartsProtected + "/restHours", data, [uuid], true)(),
);

export const updateDays = createAction(
  "UPDATE_DAYS",
  (uuid, nifSociety, data) =>
    apiPut(
      urlWorkingPartsProtected + "/updateDays",
      data,
      [uuid, nifSociety],
      true,
    )(),
);

export const sendA3 = createAction("SEND_A3", (obj) =>
  apiPost(urlA3Protected, obj, undefined, true)(),
);

export const multipleA3 = createAction("SEND_MULTIPLE_A3", (obj) =>
  apiPost(urlA3multipleSecured, obj, undefined, true)(),
);

export const listSnapToExport = createAction(
  "LIST_SNAP_TO_EXPORT",
  (filter, param) =>
    apiGet(
      urlWorkingPartExportProtected + generateFilterQuery(filter),
      param,
      true,
    )(),
);



export const allSnap = createAction("ALL_SNAPSHOTS", (filter, param) =>
  apiGet(
    urlWorkingPartsAllProtected + generateFilterQuery(filter),
    param,
    true,
  )(),
);

export const journeysA3 = createAction("SEND_A3", (obj) =>
  apiPost(urlJourneyA3Protected, obj, undefined, true)(),
);

export const multipleJourneysA3 = createAction("SEND_MULTIPLE_A3", (obj) =>
  apiPost(urlA3multipleJourneysSecured, obj, undefined, true)(),
);
